module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', {
    attrs: {
      "id": "v_main"
    }
  }, [(_vm.$route.path == '/login') ? [_c('router-view', {
    staticClass: "login"
  })] : [_vm._v("\n            " + _vm._s(_vm.$store.domain) + "\n            "), (_vm.getUser) ? _c('v-bottom-navigation', {
    staticClass: "h-panel",
    model: {
      value: (_vm.bar),
      callback: function($$v) {
        _vm.bar = $$v
      },
      expression: "bar"
    }
  }, [_c('v-btn', {
    staticClass: "d-none",
    attrs: {
      "value": "0"
    }
  }, [_c('span', [_vm._v("css")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-file-code"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "value": "css"
    }
  }, [_c('span', [_vm._v("css")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-file-code"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "value": "setting"
    },
    on: {
      "click": function($event) {
        _vm.$refs.mod.dialogDescription = true
      }
    }
  }, [_c('span', [_vm._v("Настройки")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-cog"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "value": "exit"
    }
  }, [_c('span', [_vm._v("Выход")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-sign-out-alt"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.getPageLoad !== true && _vm.getTemplateLoad !== true) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "cssload-thecube"
  }, [_c('div', {
    staticClass: "cssload-cube cssload-c1"
  }), _vm._v(" "), _c('div', {
    staticClass: "cssload-cube cssload-c2"
  }), _vm._v(" "), _c('div', {
    staticClass: "cssload-cube cssload-c4"
  }), _vm._v(" "), _c('div', {
    staticClass: "cssload-cube cssload-c3"
  })])]) : _vm._e(), _vm._v(" "), _c('v-card', {
    class: _vm.ssr ? 'd-none' : '',
    attrs: {
      "flat": "",
      "tile": "",
      "id": "v_card_2"
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "overflow": "auto",
      "position": "fixed",
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "id": "v_card_1"
    }
  }, [_c('Header', {
    attrs: {
      "id": "header_all"
    }
  }), _vm._v(" "), _c('router-view', {
    key: _vm.$route.params.id,
    attrs: {
      "id": "all_content"
    }
  }), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('Modal', {
    ref: "mod"
  })], 1)], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec1cf36a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/App.vue
// module id = 138
// module chunks = 2